import { render } from "./AppSvg.vue?vue&type=template&id=24d20546"
import script from "./AppSvg.vue?vue&type=script&lang=js"
export * from "./AppSvg.vue?vue&type=script&lang=js"

import "./AppSvg.vue?vue&type=style&index=0&id=24d20546&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__